// pages/limousine/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import { useRouter } from 'next/router'
import CtaButton from "../../components/buttonWithArrow";
import CategorySlider from '../../components/categories'
import ServiceCategories from "../../components/Investments/ServiceCategories";
import { ALLSERVICES_page } from "../../data/all-services";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import { Box } from "@mui/material";
import Heading from "../../components/heading";
import Blogs from "../../components/blog/blogs/Blogs";
import { BLOG_page } from "../../data/blog";
import PickYourCarGrid from "../../components/Investments/PickYourCarToServices";
import RslSuperAppBanner from '../../components/RslSuperAppBanner'
import PopularDestinations from '../../components/trending'
import { getActivitiesBlogs } from '../../redux/slices/common'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { axiosInstance } from '../../utils/axiosInstance';
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Scrollbar, Autoplay, Controller } from 'swiper'
import { Typography } from '@mui/material'
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function Activities({ meta }) {


  const router = useRouter()
  const dispatch = useDispatch()


  const { activityBlogsList } = useSelector(state => state.common)

  const [blogData, setBlogData] = useState([]);

  const [loader, setLoader] = useState(true);

  const RSL_ADMIN_BACKEND_URL = process.env.RSL_ADMIN_BACKEND_URL;

  const pageName = router.asPath.split("/").filter(Boolean)[0];
  const isActivityPage = pageName === "activities";


  useEffect(() => {
    if (!router.isReady) return;

    if (isActivityPage) {
      setLoader(true);

      const obj = {
        page: 0,
        limit: 2,
        status: "A",
        type: isActivityPage ? 2 : 1, // 2 = activities
      };

      dispatch(getActivitiesBlogs(obj));
    }
  }, [dispatch]);


  // console.log("blogData",blogData);

  useEffect(() => {

    if (activityBlogsList && activityBlogsList !== undefined) {
      setLoader(false);
      setBlogData(activityBlogsList?.responseData?.all_blog_list)
    }
  }, [activityBlogsList])


  const handleViewAll = async () => {
    try {
      //  const obj = {
      //   "page": 0,
      //   "limit": 20,
      //   "status": "A",
      //   "type": isActivityPage ? 2 : 1,
      // }

      // const response = await axiosInstance.post(`${RSL_ADMIN_BACKEND_URL}/activityBlogs/list`,obj);
      // console.log("Fetched blogs:", response.data);
      // You can set state or redirect here
      // e.g., setBlogs(response.data) or 
      // 
      router.push("/blogs?activities")

    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section className='masthead_rsl -type-3' style={{
        position: "relative",
        width: "100%",
        height: bannerHeight(),
        overflow: "hidden",
      }}>
        {/* Fixed background layer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          <div className='masthead_rsl__bg'>
            <Swiper
              spaceBetween={20}
              className='overflow-visible'
              scrollbar={{ draggable: true }}
              style={{ height: '100%' }}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              modules={[Controller, Autoplay, Scrollbar, Navigation]}
              navigation={{
                nextEl: '.js-second-destination-next',
                prevEl: '.js-second-destination-prev'
              }}
            >
              <SwiperSlide>
                <div style={{ position: "relative", width: "100%", height: "100%" }}>
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='video-background'
                  >
                    <source
                      src={`${process.env.IMAGE_BASE_URL}/video/Activites.mp4`}
                      type='video/mp4'
                    />
                    Your browser does not support the video tag.
                  </video>

                  {/* Gradient overlay */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      top: 0,
                      background: "linear-gradient(to top, rgb(62 62 62) 0%, rgba(0, 0, 0, 0) 35%)",
                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  />
                  {/* Bottom overlay */}
                  <div className='container for-mobile for-filter rsl__Wrapper' style={{ zIndex: 2 }}>
                    <div className='row justify-center'>
                      <div className='col-auto'>
                        <div className='masthead_rsl__tabs rsl-tab_md'>
                          <Box
                            sx={{
                              position: "absolute",
                              // top :{md: -10},
                              left: { xs: -10, sm: "8%", md: "1%" },
                              right: { xs: 2, sm: "clamp(16px,4vw,64px)" },
                              bottom: "clamp(24px, 18vh, 40px)",   // default
                              zIndex: 2,
                              pointerEvents: "none",
                              width: { xs: "auto", md: 1100 },

                              // tablet-only override (768–899.95px)
                              "@media (min-width:768px) and (max-width:899.95px)": {
                                top: -330,
                                bottom: "auto",                    // IMPORTANT: cancel bottom so top takes effect
                                // transform: "translate(-50%, 0)", // add only if you need a vertical translate
                              },
                            }}
                          >
                            <Typography
                              component="h1"
                              className='jura'
                              sx={{
                                m: 0,
                                textAlign: "center",
                                color: "#fff",
                                // lineHeight: { xs: 1.25, md: 1.1 },
                                // fontWeight: { xs: 400, md: 700 },
                                // fontSize: { xs: 22, sm: 26, md: 40 },
                                fontWeight: 800,
                                fontSize: 40,
                                px: { xs: 2, md: 0 },
                                position: "relative"
                              }}
                            >
                              Top Class UAE {""}
                              <span style={{
                                position: "relative", display: "inline-block",
                              }}>
                                Activities
                                <img
                                  src="/img/header/Oval.svg"
                                  alt="highlight"
                                  style={{
                                    position: "absolute",
                                    width: "211.66px",
                                    height: "auto",
                                    top: "-6px",
                                    left: "-5px",
                                    transform: "rotate(4deg)",
                                    opacity: 1,
                                    zIndex: -1,
                                    pointerEvents: "none",
                                  }}
                                />
                              </span>
                            </Typography>

                            {/* 
                          <div className="cta">
                            <CtaButton label="Explore Now" endIconSrc="/img/header/VectorTopRight.svg" onClick={() => console.log("Your are clicked Download App.")} />
                          </div> */}

                          </Box>


                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      {/* 👇 important: push content BELOW fixed hero */}
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
          background: "#fff"
        }}
      >
        <Box
          sx={{
            position: "relative",
            textAlign: "center",
            mb: { xs: 4, md: 6 },
            mt: { xs: 3, md: 4 },
          }}
        >
          <img
            src="/img/header/cloud.svg"
            alt="Left Cloud"
            style={{
              position: "absolute",
              top: "90%",
              left: "18%",
              width: "12vw",
              minWidth: "40px",
              maxWidth: "70px",
              opacity: 0.8,
            }}
          />

          <img
            src="/img/header/cloud.svg"
            alt="Right Cloud"
            style={{
              position: "absolute",
              top: "50px",
              right: "20%",
              width: "13vw",
              maxWidth: "60px",
              opacity: 0.8,
            }}
          />

          <img
            src="/img/header/plane.svg"
            alt="Plane"
            style={{
              position: "absolute",
              top: "60%",
              right: "3%",
              width: "14vw",
              maxWidth: "90px",
              transform: "rotate(-5deg)",
              opacity: 0.9,
            }}
          />

          <img
            src="/img/header/tree.svg"
            alt="Palm Tree"
            style={{
              position: "absolute",
              top: "80%",
              left: "4%",
              width: "100px",
              zIndex: 5,
            }}
          />


          <img
            src="/img/header/ring.svg"
            alt="Ring"
            style={{
              position: "absolute",
              top: "118%",
              right: "11%",
              width: "130px",
              zIndex: 5,
              opacity: 0.9,
            }}
          />

          <Heading
            title="Explore Our Categories"
            subtitle="Make journey comfortable with"
          />
        </Box>



        <Box textAlign="center" mb={4} mt={4}>
          <CategorySlider router={router} pageName={pageName} />
        </Box>


        <div className="cta">
          <CtaButton label="Plan Trip" endIconSrc="/img/header/VectorTopRight.svg" onClick={() => router.push("/activities/activities?cityName=All&name=&destinationName=All&productId=")} />
        </div>

        <Box textAlign="center" mb={4} mt={4}>
          <Heading title="RSL Recommendations for You" subtitle="Make journey comfortable with" />
        </Box>


        <PopularDestinations
          router={router}
          pageName={pageName}
          title='Trending'
        />

        <Box textAlign="center" mb={4} mt={4}>
          <Heading title="Blogs that helps to choose activity" subtitle="Make journey comfortable with" />
        </Box>

        <Box className="blog-section" sx={{ position: "relative", overflow: "visible", mt: 4, mb: 4 }}>
          <img
            src="/img/header/passport.svg"
            alt="Photo stack"
            className="decor decor-left1"

          />

          <img
            src="/img/header/pass2.svg"
            alt="Camera"
            className="decor decor-top-right1"
          />
        </Box>


        <Box id="section2" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <Blogs data={blogData ? blogData.slice(0, 2) : BLOG_page?.blogData} right={{ xs: 0, md: 10, lg: 100, xl: 90 }} buttonMarginTop={{ xs: 0, md: 0 }} onClick={() => console.log("")} />
        </Box>
        <Box
          id="section2"
          sx={{
            display: "flex",
            justifyContent: "center", // ✅ centers horizontally
            alignItems: "center",     // ✅ centers vertically (optional)
            width: "100%",            // ensures full width for centering
            mt: 4,                    // optional margin top
          }}
        >
          <CtaButton
            label="View All"
            endIconSrc="/img/header/VectorTopRight.svg"
            onClick={handleViewAll}
          />
        </Box>

        <Box sx={{ py: 4, px: { xs: 2, md: 4 } }}>
          <RslSuperAppBanner />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 72vh, 80vh);
          min-height: ${bannerHeight()}
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.1em;
          top: -10px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}